<template>
  <div class="md-card" style="margin:20px 0px 20px 0px">
    <div class="md-layout" style="margin-bottom:0px; padding:0px 10px">
      <div class="md-layout-item md-size-15 md-medium-size-33 md-xsmall-size-90">
        <img :src="avatarUrl" @error="imgNotLoaded" style="max-width:120px;margin-bottom:20px" />
      </div>
      <div class="md-layout-item" style="margin-left:10px;p">
        <h3
          class="bold text-primary"
          style="margin:0px"
        >{{item.description.firstName}} {{item.description.lastName}}</h3>
        <h6 class="text-gray regular">{{item.description.country}}</h6>
        <h6 class="text-gray regular" style="margin:0px 10px 0px 0px">{{item.description.position}}</h6>
        <h6 class="text-gray regular" style="margin:0px 10px 10px 0px">{{item.description.company}}</h6>
        <div
          class="text-gray regular"
          style="margin:0px 10px 0px 0px"
          v-if="item.description.description"
        >{{item.description.description}}</div>

        <h6 class="text-primary" style="margin:0px 10px 0px 0px" v-if="item.linkedIn">
          <i class="fab fa-linkedin" style="margin-right:5px"></i>
          <a :href="linkedInUrl" target="_blank" class="text-primary">{{item.linkedIn}}</a>
        </h6>
        <h6 class="text-primary" style="margin:0px 10px 0px 0px" v-if="item.twitter">
          <i class="fab fa-twitter" style="margin-right:5px"></i>
          <a :href="twitterUrl" target="_blank" class="text-primary">{{item.twitter}}</a>
        </h6>
      </div>
    </div>
    <div class="md-layout md-layout-item md-size-100" style="margin-bottom:5px">
      <div class="ml-auto">
        <md-button
          v-if="hasChatAccess && item.canChat"
          @click="openChat"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:10px 10px 0px 10px"
        >{{$t('Chat with me')}}</md-button>

        <md-button
          v-if="showDetailsLink"
          @click.prevent="gotoDetails(item.id)"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:10px 10px 0px 10px"
        >{{$t('Go to details')}}</md-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/util/axios";

export default {
  props: ["item", "showDetailsLink"],
  computed: {
    ...mapGetters({
      language: "language/current",
      hasAttendeesAccess: "user/hasAttendeesAccess",
      conference: "conference/current",
      hasChatAccess: "user/hasChatAccess"
    }),
    description() {
      return this.item.description;
    },
    linkedInUrl() {
      return this.item.linkedIn;
    },
    twitterUrl() {
      return this.item.twitter;
    },
    avatarUrl() {
      return axios.getAttendeeAvatarUrl(
        this.conference.year,
        this.conference.type,
        this.item.externalId
      );
    }
  },
  data() {
    return {
      shadowNormal: {
        type: Boolean,
        default: false
      },
      noColoredShadow: {
        type: Boolean,
        default: false
      },
      imgLoaded: false
    };
  },
  methods: {
    gotoDetails(id) {
      var route = this.$router.resolve({
        name: "attendeeDetails",
        params: { id: id }
      });
      window.open(route.href, "_blank");
    },
    imgNotLoaded(event) {
      if (!this.imgLoaded) {
        event.target.src = require("@/assets/img/blank_avatar.png");
      }
      this.imgLoaded = true;
    },
    cardLink() {},
    shadowImageProfile(image) {
      //      return {};
      return {
        backgroundImage: `url(${image})`,
        opacity: 1
      };
    },
    async openChat() {
      let self = this;
      let loader = this.$loading.show();

      try {
        var details = (
          await axios.get("/chat/users/details", {
            params: {
              conferenceYear: this.conference.year,
              conferenceType: this.conference.type,
              externalId: self.item.externalId
            }
          })
        ).data;

        if (details.canHeChat) {
          this.$router.push({ name: "chat", params: { id: details.userId } });
        } else {
          this.$swal({
            icon: "info",
            title: self.$t("Info"),
            text: self.$t("Chat inactive for the selected user")
          });
        }
      } finally {
        loader.hide();
      }
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
h6 {
  text-transform: none !important;
  font-size: 0.85rem;
}

.justify-content-center {
  justify-content: center !important;
}
.md-card-horizontal .md-card-header-image {
  margin-bottom: 1rem;
}

.md-card {
  margin: 10px 0px;
  padding: 10px;
  box-shadow: 0px 0px 30px #0000001a;
  border-radius: 30px;
  opacity: 1;
}
</style>



